import { Beaker, Home, Menu, Plus, ScanLine, UserRound } from 'lucide-react';
import { NavLink, Outlet, ScrollRestoration } from 'react-router-dom';

const navClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'nav-link active' : 'nav-link');

export function Layout() {
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main">Skip to content</a>
      <header className="topbar">
        <button className="icon-button menu-placeholder" aria-label="Open menu" type="button"><Menu size={18} /></button>
        <NavLink to="/" className="wordmark" aria-label="STYLE home">STYLE</NavLink>
        <nav className="desktop-nav" aria-label="Primary navigation">
          <NavLink to="/discover" className={navClass}>Discover</NavLink>
          <NavLink to="/recommendations" className={navClass}>Selection</NavLink>
          <NavLink to="/profile" className={navClass}>Profile</NavLink>
        </nav>
        <NavLink to="/profile" className="icon-button profile-link" aria-label="Open your profile"><UserRound size={18} /></NavLink>
      </header>
      <main id="main"><Outlet /></main>
      <nav className="bottom-nav" aria-label="Mobile navigation">
        <NavLink to="/" className={navClass} aria-label="Home"><Home size={19} /></NavLink>
        <NavLink to="/recommendations" className={navClass} aria-label="Recommendations"><Beaker size={19} /></NavLink>
        <NavLink to="/discover" className="create-link" aria-label="Start new discovery"><Plus size={24} /></NavLink>
        <NavLink to="/style" className={navClass} aria-label="Style Card"><ScanLine size={20} /></NavLink>
        <NavLink to="/profile" className={navClass} aria-label="Profile"><UserRound size={19} /></NavLink>
      </nav>
      <ScrollRestoration />
    </div>
  );
}
